import { METADATA_NAMES } from "../common/form/formConstants";
import { group, productionType, projectStatus } from "../production/helpers/productionImportUtils";

export const hasSavedEntityReference = (row?: { reference?: { id?: string } }) => Boolean(row?.reference?.id);

export const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const PIPELINE_IMPORT_LOOKUP_COLUMNS = [
    {
        column: productionType,
        entityName: METADATA_NAMES.showType,
        options: { sortBy: 'name', allowFreeText: false }
    },
    {
        column: projectStatus,
        entityName: METADATA_NAMES.creativeSubmissionStatus,
        options: { sortBy: 'order', allowFreeText: false }
    },
    {
        column: group,
        entityName: METADATA_NAMES.group,
        options: { sortBy: 'order', allowFreeText: false }
    }
];